<script setup lang="ts">
import { useForm } from '@inertiajs/vue3'
import Card from '@/Components/Card.vue'
import TextArea from '@/Components/Form/TextArea.vue'
import Input from '@/Components/Form/Input.vue'
import PrimaryButton from '../Buttons/PrimaryButton.vue'

const form = useForm({
    content: '',
    password: '',
})

function submit() {
    form.post(route('guest.secrets.store'), {})
}
</script>

<template>
    <Card class="mx-auto max-w-xl text-center">
        <div
            class="absolute inset-0 mx-auto mt-12 max-w-xl rounded-xl border border-solid border-gray-200 bg-[linear-gradient(to_bottom,#fff_0%,#f7f7f7_50%,#fff_100%)]"
        ></div>
        <span class="relative z-[1] text-2xl font-bold text-primary-500">Jetzt KOSTENLOS ausprobieren!</span>
        <p class="relative z-[1] mt-3">
            Bitte tragen Sie Ihr Geheimnis ein. Dies können Zugangsdaten, ein Passwort oder auch etwas ganz anderes sein, dass Sie sicher
            teilen möchten. Wir empfehlen, Ihr Geheimnis optional noch durch ein starkes Passwort zusätzlich zu schützen.
        </p>
        <form @submit.prevent="submit">
            <div class="mt-4 space-y-4">
                <div>
                    <TextArea
                        v-model="form.content"
                        placeholder="Ihr Geheimnis (Passwort o.Ä.)"
                        name="content"
                        label="Geheimnis"
                        label-hidden
                        required="true"
                        autocomplete="off"
                        class="w-full"
                    />
                    <p
                        v-if="form.errors.content"
                        class="text-primary-500"
                    >
                        {{ form.errors.content }}
                    </p>
                </div>
                <Input
                    v-model="form.password"
                    placeholder="Passwort für Ihren Link (optional)"
                    label="Passwort"
                    label-hidden
                    type="password"
                    autocomplete="off"
                    name="password"
                />
                <div class="relative mt-4 w-full">
                    <PrimaryButton
                        class="w-full"
                        as="button"
                        type="submit"
                        icon="fa-light fa-angle-right"
                    >
                        Geheimen Link erstellen
                    </PrimaryButton>
                </div>
            </div>
        </form>
        <div>
            <p class="relative z-[1] my-4 text-xs">
                Benötigen Sie mehr Optionen, wie einen
                <span class="font-bold">Beschreibungstext, einstellbare Gültigkeit Ihres Links</span> (automatische Löschung) oder die
                Angabe von <span class="font-bold">Verwendungshinweisen</span> für Empfänger?
            </p>
            <a
                href="#Preise"
                class="relative z-[1] text-primary-500 underline decoration-transparent outline-none transition-all hover:decoration-current focus:decoration-current"
            >
                Mehr über Pro-Features erfahren
                <i class="fa-light fa-angle-right"></i>
            </a>
        </div>
    </Card>
</template>
